attachEvent('.copy-button__btn', 'click', (ev) => {
  const parent = ev.target.closest('.copy-button');
  const textToCopy = parent.querySelector('.copy-button__copy-text');
  const range = document.createRange();
  const selection = window.getSelection();

  range.selectNodeContents(textToCopy);
  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
  parent.classList.add('show');
  window.getSelection().removeAllRanges();

  setTimeout(() => {
    parent.classList.remove('show');
  }, 1000);

  ev.preventDefault();
});
